import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="forms--defta-custom-one"
export default class extends Controller {
  connect() {
  }
}
